module.exports = __webpack_public_path__ + "static/img/other6.b202676.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other6.png
// module id = KONe
// module chunks = 1